import { IFileUploadData } from '@northladder/services';

import { ApiClient } from '../api-client';

import { IVideoUploadPayload } from './types';

/**
 * This is provides the API client methods related to the Video-Image Service.,
 */
export class VideoImageApiClient extends ApiClient {
  private static classInstance?: VideoImageApiClient;

  private constructor() {
    super({
      // TODO: Add the correct URL for video upload in the future.
      apiBaseURL: 'CUSTOMER_SERVICE_BASE_URL',
    });
  }

  /**
   * Applying the dreaded singleton pattern here to reuse the axios instance.
   */
  public static getClientInstance = () => {
    if (!this.classInstance) {
      this.classInstance = new VideoImageApiClient();
    }

    return this.classInstance;
  };

  //----------------------------------------------------------------------------
  // ------------------Image/Video upload file API call----------------------
  //----------------------------------------------------------------------------

  /**
   * API call to upload files such as license, other certificates and documents.
   */
  /**
   * API call to upload videos/images as documents.
   */
  public videoUpload = async (payload: IVideoUploadPayload) => {
    const uploadVideoUrl = payload.apiEndPoint;
    const response = await this.post<IFileUploadData>(
      uploadVideoUrl,
      payload.file,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        cancelToken: payload.cancelToken.token,
        requiresAuth: false,
        timeout: 5 * 60 * 1000, // Force a 5 minute wait on uploads.
        onUploadProgress: payload.onUploadProgress,
        // TODO: @divyansh - This key is not present in the IApiConfiguration type.
        // TODO: Are you sure you are using it and whether is shouldn't be removed?
        // Pass the actual file size for accurate progress calculation
        // fileSize: payload.fileSize, // Commented out as it's breaking build.
      }
    );

    if (!response.success) throw response;

    return response.data;
  };
}

/**
 * This creates a new instance of the class. is th base Axios API client Class
 * wrapper for All User Video/Image Service related requests.
 */
export const VIDEO_IMAGE_SERVICE_API = VideoImageApiClient.getClientInstance();
